import { getDefaultStaticProps } from '@/shared/utils/getDefaultProps';
const Home = () => {
  return null;
};
export default Home;
export const getStaticProps = getDefaultStaticProps;